<template>
  <div class="main register">
    <div class="header">
      <a class="backBtn" v-if="step !== 1" @click="back" href="#">
        <i class="icon_back"></i> {{ $t('back') }}
      </a>
    </div>
    <div class="mainBox">
      <div class="page">
        <div class="title">{{ title }}</div>
        <template v-if="step === 1">
          <h2 class="reg">{{ $t('registerPage.firstStepTitle') }}</h2>
          <p>{{ $t('registerPage.firstStepDescription') }}</p>
        </template>
        <template v-else-if="step === 2">
          <div class="selectItem">
            <a @click="userData.gender = 'M'" href="#" :class="{'active': userData.gender === 'M'}">{{ $t('registerPage.male') }}</a>
            <a @click="userData.gender = 'F'" href="#" :class="{'active': userData.gender === 'F'}">{{ $t('registerPage.female') }}</a>
          </div>
        </template>
        <template v-else-if="step === 3">
          <select class="form-control" v-model="userData.age">
            <option v-for="age in ageList" :key="age">{{ age }}</option>
          </select>
        </template>
        <template v-else-if="step === 4">
          <input type="text" class="name" v-model="userData.name" />
        </template>
        <button class="btn_w" @click="validate">{{ this.step === 4 ? $t('registerPage.submit') : $t('registerPage.next')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      step: 1,
      ageList: [],
      userData: {
        gender: 'M',
        age: new Date().getFullYear() - 20,
        name: '',
	  },
    }
  },
  created() {
    this.ageList = []
    for (let i = 1970; i <= new Date().getFullYear(); i++) {
      this.ageList.push(i)
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
    ]),
    title() {
      const titleList = {
        1: this.$t('registerPage.register'),
        2: this.$t('registerPage.gender'),
        3: this.$t('registerPage.age'),
        4: this.$t('registerPage.nickname'),
      }
      return titleList[this.step]
    },
  },
  methods: {
    ...mapMutations([
      'updateUserInfo',
    ]),
    ...mapActions([
      'trackerLog',
    ]),
    back() {
      if (this.step !== 1) {
        this.step -= 1
      }
    },
    next() {
      if (this.step !== 4) {
        this.step += 1
      } else {
        const data = {
          age: new Date().getFullYear() - this.userData.age,
          gender: this.userData.gender,
          userId: this.userInfo.uid,
          userName: this.userData.name,
        }

        this.$LoginAPI.register(data)
          .then(() => {
            this.updateUserInfo({
              name: data.userName,
            })
            // log
            this.trackerLog({
              event: 'register',
              message: {
                userId: data.userId,
                userName: data.userName,
              },
            })

            this.$router.push({ name: 'Start' })
          }).catch((err) => {
            console.error(err)
            this.$alert.wraningAlert(this.$t('registerPage.failure'))
            this.$router.push({ name: 'Login' })
          })
      }
    },
    validate() {
      const fieldList = {
        2: 'gender',
        3: 'age',
        4: 'name',
      }

      const fieldName = fieldList[this.step]
      if (this.userData[fieldName] || this.step === 1) {
        this.next()
      } else if (!this.userData.name) {
        this.$alert.wraningAlert(this.$t('registerPage.nameIsRequired'))
      }
    },
  },
}
</script>

<style>

</style>
